function onlyDigits(value: string): string {
  return value.replace(/\D/g, '');
}

const E164_PHONE_REGEX = /^\+[1-9]\d{7,14}$/;

export function normalizePhone(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  const digits = onlyDigits(trimmed);
  if (!digits) return '';

  if (trimmed.startsWith('+')) {
    const normalized = `+${digits}`;
    return E164_PHONE_REGEX.test(normalized) ? normalized : '';
  }

  if (trimmed.startsWith('00') && digits.length > 2) {
    const normalized = `+${digits.slice(2)}`;
    return E164_PHONE_REGEX.test(normalized) ? normalized : '';
  }

  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  return '';
}

export function isValidPhone(value: string): boolean {
  return normalizePhone(value).length > 0;
}
